import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BaseComponent } from '@wms/app/components';
import { DialogService } from '@wms/app/services/dialog/dialog.service';
import { ApisService } from '@wms/app/services';
import { WmsDialogComponent, WmsDialogHeaderComponent, WmsDialogBodyComponent, WmsDialogFooterComponent } from '@wms/components';
import { ImportApiComponent } from '../import-api/import-api.component';
import {VersionManagerPipe} from "@wms/core";

@Component({
  standalone: true,
  selector: 'wms-empty-screen',
  templateUrl: './empty-screen.component.html',
  styleUrls: ['./empty-screen.component.less'],
  imports: [
    WmsDialogComponent,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    ImportApiComponent,
    VersionManagerPipe
  ]
})
export class EmptyScreenComponent extends BaseComponent implements OnInit {
  @Output() refreshService = new EventEmitter<any>();
  constructor(private dialogService: DialogService, public apiService: ApisService) {
    super();
  }

  ngOnInit(): void {
    this.apiService.emptyScreenCounter = 0;
  }

  customRefreshService(): void {
    this.refreshService.emit();
  }

  closeDialogWithId(id: string): void {
    this.dialogService.close(id)
  }
}
